module.exports = __webpack_public_path__ + "static/media/PHONE_MOCKUP.ad80cea3.png";